import { render } from "./SiteFeatured.vue?vue&type=template&id=3cb3daf8"
import script from "./SiteFeatured.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteFeatured.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteFeatured.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cb3daf8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cb3daf8', __exports__)) {
    api.reload('3cb3daf8', __exports__)
  }
  
  module.hot.accept("./SiteFeatured.vue?vue&type=template&id=3cb3daf8", () => {
    api.rerender('3cb3daf8', render)
  })

}


export default __exports__